// Third Party Library
import React, { useState } from "react";
import { Layout, Space, Row, Col, Form, Input, message, Card } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

// Constants
import { ROUTE } from "../../../../constants";
import { APP_CONFIG } from "../../../../config";

// Components
import { LoginHeader, CopyRightFooter } from "../../../../components";
import SSOFPFooter from "../SSOFPFooter";

import * as ACTIONS from "../../../../services/redux/actions";

// Style
import styles from "../../../index.module.css";

const { Content } = Layout;
const { MODULE_ROUTE } = ROUTE;

const SSOForgotPasswordNewPassword = (props) => {
  const { authid } = props;

  const authProvider = APP_CONFIG.AUTHENTICATION_PROVIDER;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const [loadingReset, setLoadingReset] = useState(false);

  const onFinish = () => {
    form.validateFields().then((value) => {
      const { password } = value;

      messageApi.open({
        type: "loading",
        content: "Create new password...",
        duration: 0,
      });

      dispatch(
        ACTIONS.main_user.sso_user_auth_reset_user_password_request(
          { authid, authProvider },
          password,
          ({ status, err }) => {
            if (status === 200) {
              messageApi.destroy();
              setLoadingReset(false);
              navigate(MODULE_ROUTE.FORGOT_PASSWORD_SUCCESS);
            } else {
              messageApi.destroy();
              setLoadingReset(false);
              message.error(err);
            }
          }
        )
      );

      setLoadingReset(true);
    });
  };

  return (
    <>
      {contextHolder}
      <div className={styles.mainWrap}>
        <Card className={styles.mainCard}>
          <Space direction="vertical" style={{ width: "100%" }} size={[0, 48]}>
            <Layout style={{ backgroundColor: "#ffffff" }}>
              <LoginHeader />

              <Content style={{ marginTop: "40px" }}>
                <Col style={{ textAlign: "center" }} span={8} offset={8}>
                  <h2 className={styles.textTitle}>Reset Password</h2>
                  <p className={styles.textDetailsForgetPass}>
                    Enter a new password below to change your password.
                  </p>

                  <Form
                    form={form}
                    initialValues={{
                      remember: true,
                    }}
                    layout="vertical"
                  >
                    <label htmlFor="name" className={styles.labelInput}>
                      New Password <span style={{ color: "red" }}>*</span>
                    </label>
                    <Form.Item
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: "Please input your password!",
                        },
                        {
                          pattern:
                            /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$/,
                          message:
                            "Password must be a minimum of 8 characters, at least one lowercase letter (a-z), at least one uppercase letter (A-Z) and at least one number (0-9).",
                        },
                      ]}
                      hasFeedback
                    >
                      <Row>
                        <Input.Password
                          className={styles.inputMain}
                          allowClear
                        />
                      </Row>
                    </Form.Item>

                    <label htmlFor="name" className={styles.labelInput}>
                      Confirm Password <span style={{ color: "red" }}>*</span>
                    </label>
                    <Form.Item
                      name="confirmPassword"
                      dependencies={["password"]}
                      hasFeedback
                      rules={[
                        {
                          required: true,
                          message: "Please confirm your password!",
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || getFieldValue("password") === value) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error("Password doesn't match!")
                            );
                          },
                        }),
                      ]}
                    >
                      <Row>
                        <Input.Password
                          className={styles.inputMain}
                          allowClear
                        />
                      </Row>
                    </Form.Item>
                  </Form>
                </Col>
              </Content>
              <SSOFPFooter
                loading={loadingReset}
                page={MODULE_ROUTE.FORGOT_PASSWORD_6_DIGITS_CODE}
                submit={onFinish}
              />
            </Layout>
          </Space>
        </Card>

        <CopyRightFooter />
      </div>
    </>
  );
};

export default SSOForgotPasswordNewPassword;
